import { FC } from "react"

import { Icon } from "components/Icon"

export const CollapseIcon: FC<{
    collapsed: boolean
    onClick?: () => void
}> = (props) => {
    return (
        <span onClick={() => props.onClick?.()}>
            {props.collapsed ? (
                <>
                    <Icon className="collapse-icon__mobile" type="chevron-down" size={24} />
                    <Icon className="collapse-icon__desktop" type="chevron-big-down" size={24} />
                </>
            ) : (
                <>
                    <Icon className="collapse-icon__mobile" type="chevron-up" size={24} />
                    <Icon className="collapse-icon__desktop" type="chevron-big-up" size={24} />
                </>
            )}
        </span>
    )
}
